export default "__VITE_ASSET__CjQEG9HG__"